import { formatNumber } from './formatNumber';
import { NBSP } from '../../constants/symbols';

export function formatAuctionPoints(points: number): string {
  return `${formatNumber(points)}${NBSP}Б`;
}
